import axios from 'axios'
import {apiBaseUrl} from '../../../helpers/UrlHelper'
import {loginToken} from '../../../helpers/LocalStorageHelper'
import {handleError, handleSuccess} from '../../../helpers/ErrorHelper'
import getSite from "../../../ajax/actions/sites/site_get";
import store from "../../../Store";
import getSiteStatus from "../sites/site_status_get";
import {toggleSearchAndReplaceFormModal} from "../../../pages/site/feature-block/list/FeatureBlock-Action";
import {cancelSearchAndReplaceFormDispatch} from "../../../pages/site/searchandreplace/form/SearchAndReplaceForm-Action";

function _success(success) {
    return {type: 'POST_REPLACE_SUCCESS', success}
}

function _error(error) {
    return {type: 'POST_REPLACE_ERROR', error}
}

function _processing(processing) {
    return {type: 'POST_REPLACE_PROCESSING', processing}
}

function replace() {
    return (dispatch, getState) => {
        dispatch(_processing(true));
        dispatch(_success(null));
        dispatch(_error(null));

        let {SftpList, organizationDashboard , searchAndReplaceForm} = getState();
        let { site_id} = SftpList.data;
        let payload = searchAndReplaceForm.data.payload
        let org_id = organizationDashboard.data.organization_id;

        axios({
            url: apiBaseUrl(`admin/organizations/${org_id}/sites/${site_id}/tools/replace`),
            method: 'post',
            dataType: 'json',
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + loginToken()
            }
        })
            .then(function (res) {
                dispatch(_success(res))
                dispatch(_processing(false))
                // handleSuccess("Monitoring request sent Successfully")
                handleSuccess(res.data.message)
                store.dispatch(cancelSearchAndReplaceFormDispatch())
                store.dispatch(getSite(site_id, org_id))
                store.dispatch(getSiteStatus(site_id, org_id))
                store.dispatch(toggleSearchAndReplaceFormModal())


            }).catch(function (error) {

            dispatch(_error(error))
            dispatch(_processing(false))
            handleError(error)
        })
    }
}

export default replace;
